<div class="w-full h-[70vh] flex flex-col justify-center items-center gap-12">
  <img
    src="/assets/images/under-constructor.jpg"
    class="w-[60%] max-w-[300px] rounded-full"
  />
  <h3 class="!font-semibold !text-xl !text-primary-main">در حال توسعه</h3>
</div>
